import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getCategoryList = createAsyncThunk(
  "get-category",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("category/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createCategory = createAsyncThunk(
  "create-category",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("category", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editCategory = createAsyncThunk(
  "edit-category",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`category/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateCategory = createAsyncThunk(
  "update-category",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/category/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "delete-category",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/category/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.categoryList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getCategoryList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default categorySlice.reducer;
